import * as Sentry from "@sentry/react";
import { browserTracingIntegration, replayIntegration } from "@sentry/react";

export function stripSentryUrlDetails(
  value: string | undefined,
): string | undefined {
  if (!value) return value;
  try {
    const url = new URL(value, window.location.origin);
    return `${url.origin}${url.pathname}`;
  } catch {
    return value.split(/[?#]/, 1)[0];
  }
}

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return; // silently skip if DSN not configured

  const isProd = import.meta.env.PROD;

  Sentry.init({
    dsn,
    environment: isProd ? "production" : "development",
    release: `anchorstay-dashboard@${(import.meta.env.VITE_APP_VERSION as string) ?? "1.0.0"}`,
    integrations: [
      browserTracingIntegration(),
      replayIntegration({
        maskAllText: true,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: isProd ? 0.2 : 1.0,
    replaysSessionSampleRate: isProd ? 0.05 : 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    attachStacktrace: true,
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === "console") return null;
      if (breadcrumb.data?.url) {
        breadcrumb.data.url = stripSentryUrlDetails(
          String(breadcrumb.data.url),
        );
      }
      return breadcrumb;
    },
    beforeSend(event) {
      event.user = undefined;
      if (event.request) {
        event.request = {
          method: event.request.method,
          url: stripSentryUrlDetails(event.request.url),
        };
      }
      return event;
    },
  });
}

export { Sentry };
